import { render, staticRenderFns } from "./modalDadosParcelaReceber.vue?vue&type=template&id=0885dddd"
import script from "./modalDadosParcelaReceber.vue?vue&type=script&lang=js"
export * from "./modalDadosParcelaReceber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports